export const INSERT_LOCATION_MUTATION = `
  mutation InsertLocation($input: LocationInsertInput!) {
    insertLocation(input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const UPDATE_LOCATION_MUTATION = `
  mutation UpdateLocation($filter: String!, $input: LocationUpdateInput!) {
    updateLocation(filter: $filter, input: $input) {
      itemId
      totalImpactedData
      acknowledged
    }
  }
`;

export const DELETE_LOCATION_MUTATION = `
  mutation DeleteLocation($filter: String!, $input: LocationDeleteInput!) {
    deleteLocation(filter: $filter, input: $input) {
      acknowledged
      totalImpactedData
    }
  }
`;
